import fetch from "./fetch";
/**
 * 权限菜单
 */
const permission = {
  //根据角色id获取权限
  getRolePermission(params) {
    return fetch({
      isLoading: true,
      url: "/sys-permission/v1/sys/getUserPermission",
      method: "GET",
      params
    });
  },
  //修改角色权限
  updateRolePermission(data) {
    return fetch({
      isLoading: true,
      url: "/sys-permission/v1/sys/updatePermission",
      method: "POST",
      data
    });
  },
  //获取角色列表
  getRoleList(params) {
    return fetch({
      isLoading: true,
      url: "/sys-role/v1/sys/role",
      method: "GET",
      params
    });
  },
  //新增/修改角色
  saveRole(data) {
    return fetch({
      isLoading: true,
      url: "/sys-role/v1/sys/save",
      method: "POST",
      data
    });
  },
  //根据用户查询权限
  selectRoleByUserId(params) {
    return fetch({
      isLoading: true,
      url: "/sys-permission/v1/sys/selectRoleByUserId",
      method: "GET",
      params
    });
  },

  // 用户列表
  userRequst(data) {
    return fetch({
      isLoading: true,
      url: "/sys-user/v1/sys/user",
      method: "GET",
      params: data,
    });
  },

  // 角色模糊查询
  selectRoleRequst(data) {
    return fetch({
      isLoading: false,
      url: "/sys-role/v1/sys/selectRole",
      method: "GET",
      params: data,
    });
  },

  // 新增/编辑/删除
  setUserRequst(data) {
    return fetch({
      isLoading: true,
      url: "/sys-user/v1/sys/save",
      method: "POST",
      data,
    });
  },
}

export default permission;
